import { X } from "lucide-react";
import { dismiss, useNotices } from "../lib/notify.ts";

/** Pinned under the status bar, above everything, one tap to dismiss. */
export function Notices() {
  const notices = useNotices();
  if (notices.length === 0) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-50 flex flex-col items-center gap-2 px-4 pt-3 safe-top">
      {notices.map((notice) => (
        <button
          key={notice.id}
          type="button"
          role={notice.tone === "error" ? "alert" : "status"}
          onClick={() => dismiss(notice.id)}
          className={[
            "pointer-events-auto flex w-full max-w-md items-start gap-3 rounded-card border px-4 py-3 text-left text-[0.9rem] shadow-lg backdrop-blur-lg",
            notice.tone === "error" ? "border-stop/50 bg-base/95 text-stop" : "border-line bg-base/95 text-ink",
          ].join(" ")}
        >
          <span className="min-w-0 flex-1">{notice.message}</span>
          <X size={16} className="mt-0.5 shrink-0 opacity-60" aria-label="Fermer" />
        </button>
      ))}
    </div>
  );
}
